import styled, { css } from 'styled-components';

import { Button as DefaultButton } from '@xing-com/button';
import { Card as DefaultCard } from '@xing-com/card';
import { GridItem as DefaultGridItem } from '@xing-com/grid';
import {
  mediaConfined,
  mediaWideNavless,
  mediaSmallOrTiny,
} from '@xing-com/layout-tokens';
import { CenterContainer as DefaultCenteredContainer } from '@xing-com/platform-layout-view-wrapper';
import {
  spaceM,
  spaceL,
  xdlColorBackgroundTertiary,
  spaceXL,
  space3XL,
} from '@xing-com/tokens';
import { BodyCopy as DefaultBodyCopy } from '@xing-com/typography';

const CardContent = css`
  display: flex;
  flex-direction: column;
  gap: ${spaceM};
  justify-content: space-between;

  @media ${mediaWideNavless} {
    flex-direction: row;
    align-items: center;
  }
`;

export const Card = styled(DefaultCard)`
  display: none;
  max-width: 600px;
  @media ${mediaConfined} {
    display: flex;
  }

  & > * {
    ${CardContent}
  }
`;

export const BodyCopy = styled(DefaultBodyCopy)`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0;
`;

export const Button = styled(DefaultButton)`
  width: 258px;
`;

export const Wrapper = styled.div`
  padding: 0 ${spaceL};
`;

export const CenterContainer = styled(DefaultCenteredContainer)`
  @media ${mediaSmallOrTiny} {
    background-color: ${xdlColorBackgroundTertiary};
    padding: ${spaceXL} 0;
    margin-bottom: -${space3XL};
  }
`;

export const SmallDevice = styled.div`
  @media ${mediaConfined} {
    display: none;
  }
`;

export const GridItem = styled(DefaultGridItem)`
  @media ${mediaConfined} {
    display: flex;
    justify-content: flex-end;
  }
`;
